import React from "react";
import useFetch from "../hooks/useFetch";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import AnimatedContent from "./animation/AnimatedContent";

export default function TeamSection() {
  const teamFetch = useFetch(
    `${window.$host}/api/team?populate[Team][populate]=*`
  );

  if (teamFetch.loading) return;
  if (teamFetch.error) return;

  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 1099px)").matches;

  const MaybeAnimate = ({ enabled, children, ...props }) =>
    enabled ? <AnimatedContent {...props}>{children}</AnimatedContent> : children;

  let maxSliderWidth =
    280 * teamFetch.data.data.Team.length +
    20 * (teamFetch.data.data.Team.length - 1);

  return (
    <section className="team" id="team">
      <div className="container">
        <div className="h-100 content-box">
          <div className="team__box">
            <MaybeAnimate enabled={!isMobile} delay={0.10}>
              <div className="team__head">

                <h2 className="title-4 team__title">
                  {teamFetch.data.data.Title}{" "}
                  <span className="text-blue">
                    {teamFetch.data.data.TitleBlue}
                  </span>
                </h2>

                <div className="team__btn-next">
                  <svg
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_3321_26321)">
                      <path
                        d="M8.33899 40L0 40L8.40947e-05 -1.2964e-06L8.33907 -1.22533e-06"
                        stroke="#667085"
                        strokeWidth="0.694916"
                      />
                      <path
                        d="M24.5675 20.2457C24.7032 20.11 24.7032 19.89 24.5675 19.7543L22.3563 17.5431C22.2206 17.4074 22.0006 17.4074 21.8649 17.5431C21.7292 17.6788 21.7292 17.8988 21.8649 18.0345L23.8304 20L21.8649 21.9655C21.7292 22.1012 21.7292 22.3212 21.8649 22.4569C22.0006 22.5926 22.2206 22.5926 22.3563 22.4569L24.5675 20.2457ZM16.6777 20L16.6777 20.3475L24.3218 20.3475L24.3218 20L24.3218 19.6525L16.6777 19.6525L16.6777 20Z"
                        fill="#667085"
                      />
                      <path
                        d="M32.6611 -2.13465e-07L40.6611 0L40.6611 40L32.6611 40"
                        stroke="#667085"
                        strokeWidth="0.694916"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3321_26321">
                        <rect width="40.6611" height="40" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </MaybeAnimate>
            <MaybeAnimate enabled={!isMobile} delay={0.30}>
              <div
                className="team__slider"
                style={{ maxWidth: `${maxSliderWidth}px` }}
              >
                <Swiper
                  className="swiper team__swiper"
                  modules={[Navigation]}
                  slidesPerView={"auto"}
                  spaceBetween={20}
                  loop={true}
                  navigation={{
                    nextEl: ".team__btn-next",
                  }}
                >
                  {[0, 1].map((idx) => {
                    return teamFetch.data.data.Team.map((item) => (
                      <SwiperSlide key={item.id} className="swiper-slide">
                        <div className="team-img">
                          <img
                            src={window.$host + item.Photo.url}
                            alt={item.Photo.alternativetext}
                          />
                          <img
                            className="team-img__img-hover"
                            src={window.$host + item.PhotoBlue.url}
                            alt={item.PhotoBlue.alternativetext}
                          />
                          <div className="team-img__content">
                            <p className="text-20">{item.Description}</p>
                          </div>
                        </div>
                        <div className="team-about">
                          <h3 className="text-20 team-about__title">
                            {item.Name}
                          </h3>
                          <span className="text-gray text-12 team-about__descr">
                            {item.Job}
                          </span>
                        </div>
                      </SwiperSlide>
                    ));
                  })}
                </Swiper>
              </div>
            </MaybeAnimate>
          </div>
        </div>
      </div>
    </section>
  );
}
